import React from 'react';
import { Message } from 'semantic-ui-react';
import { useTranslation } from 'react-i18next';

const NotFound = () => {
  const { t } = useTranslation();
  return (
    <Message negative>
      <Message.Header>{t('ui.not_found_title')}</Message.Header>
      <p>{t('ui.not_found_desc')}</p>
    </Message>
  );
};

export default NotFound;
